export enum ContentType {
    TASKS,
    INSTRUCTIONS
}

export interface BulkConfirmationPayload {
    event: string
    visible: boolean
}

export enum FileSelectionType {
    BULK="BULK",
    SINGLE="SINGLE"
}
